import Vue from 'vue'

const state = Vue.observable({ current: null })
let resolveCurrent = null
let previousFocus = null

function open (kind, message, options = {}) {
  // 只响应当前弹框，避免连点触发多次提交或产生排队的危险操作。
  if (state.current) return Promise.resolve(kind === 'prompt' ? null : false)
  previousFocus = document.activeElement
  state.current = {
    kind,
    title: options.title || (kind === 'prompt' ? '请输入' : '操作确认'),
    message: String(message == null ? '' : message),
    value: String(options.defaultValue == null ? '' : options.defaultValue),
    placeholder: options.placeholder || '',
    confirmText: options.confirmText || '确定',
    cancelText: options.cancelText || '取消',
    danger: !!options.danger
  }
  return new Promise(resolve => { resolveCurrent = resolve })
}

function finish (confirmed) {
  if (!state.current || !resolveCurrent) return
  const value = state.current.kind === 'prompt' ? (confirmed ? state.current.value : null) : confirmed
  const resolve = resolveCurrent
  const focus = previousFocus
  state.current = null
  resolveCurrent = null
  previousFocus = null
  resolve(value)
  Vue.nextTick(() => {
    if (!state.current && focus && document.contains(focus) && typeof focus.focus === 'function') focus.focus({ preventScroll: true })
  })
}

export default {
  state,
  confirm (message, options) { return open('confirm', message, options) },
  prompt (message, options) { return open('prompt', message, options) },
  finish
}
